export const initialState = {
  filters: {},
  guidancePages: [],
  guidancePage: {}
};
